import { createNamespacedHelpers } from 'vuex'

import { addNetwork, deleteNetwork, editNetwork, editNetworkList, pushNetwork } from './networks'

const { mapState: mapNetworkState } = createNamespacedHelpers('network')
const { mapGetters: mapToolsGetters, mapState: mapToolsState } = createNamespacedHelpers('tools')

const NetworkMixin = {
  computed: {
    ...mapNetworkState({
      $confirmCancelNetwork: (state) => state.confirmCancelNetwork,
      $deleteIndexNetwork: (state) => state.deleteIndexNetwork,
      $deleteLabelNetwork: (state) => state.deleteLabelNetwork,
      $denyDeleteNetwork: (state) => state.denyDeleteNetwork,
      $formNetwork: (state) => state.formNetwork,
      $isModalVisibleNetwork: (state) => state.isModalVisibleNetwork,
      $isValidNetworkForm: (state) => state.isValidNetworkForm,
      $promptDeleteNetwork: (state) => state.promptDeleteNetwork,
    }),
    ...mapToolsGetters([
      'networks',
      'currentNav',
      'routeMap',
    ]),
    ...mapToolsState({
      associationId: (state) => state.associationId,
      baseReportName: (state) => state.baseReportName,
      reportPath: (state) => state.reportPath,
      routeName: (state) => state.routeName,
      subId: (state) => state.subId,
    }),

    confirmCancelNetwork: {
      get() {
        return this.$confirmCancelNetwork
      },
      set(value) {
        this.$store.commit('network/confirmCancelNetwork', value)
      },
    },
    promptDeleteNetwork: {
      get() {
        return this.$promptDeleteNetwork
      },
      set(value) {
        this.$store.commit('network/promptDeleteNetwork', value)
      },
    },
    deleteIndexNetwork: {
      get() {
        return this.$deleteIndexNetwork
      },
      set(value) {
        this.$store.commit('network/deleteIndexNetwork', value)
      },
    },
    deleteLabelNetwork: {
      get() {
        return this.$deleteLabelNetwork
      },
      set(value) {
        this.$store.commit('network/deleteLabelNetwork', value)
      },
    },
    denyDeleteNetwork: {
      get() {
        return this.$denyDeleteNetwork
      },
      set(value) {
        this.$store.commit('network/denyDeleteNetwork', value)
      },
    },
    isModalVisibleNetwork: {
      get() {
        return this.$isModalVisibleNetwork
      },
      set(newValue) {
        this.$store.commit('network/isModalVisibleNetwork', newValue)
      },
    },
    isValidNetworkForm: {
      get() {
        return this.$isValidNetworkForm
      },
      set(value) {
        this.$store.commit('network/isValidNetworkForm', value)
      },
    },

    currentRouteNetworkIndex() {
      const { associationId, baseReportName = null, routeName, reportPath, subId } = this
      return this.networks.findIndex((network) => {
        const matches = network.routeName === routeName
          && network.baseReportName === baseReportName
          && network.associationId === associationId
          && network.subId === subId
          && network.reportPath === reportPath
        return matches
      })
    },
    isCurrentNetworkFavorited() {
      return this.currentRouteNetworkIndex !== -1
    },
    networkIcon() {
      return this.isCurrentNetworkFavorited ? 'favorite' : 'favorite_border'
    },

    formDataForNetwork: {
      get() {
        return this.$formNetwork
      },
      set(value) {
        this.$store.commit('network/formNetwork', value)
      },
    },
    action: {
      get() {
        return this.formDataForNetwork.action
      },
      set(action) {
        const { entry, scope } = this.formDataForNetwork
        this.$store.commit('network/formNetwork', { action, entry, scope }, { root: true })
      },
    },
    scope() {
      return this.formDataForNetwork.scope
    },
    entry: {
      get() {
        return this.formDataForNetwork.entry || []
      },
      set(entry) {
        const { action, scope } = this.formDataForNetwork
        this.$store.commit('network/formNetwork', { action, entry, scope }, { root: true })
      },
    },

    entriesToEdit() {
      return this.entry?.filter((e) => e.isEditing) || []
    },
    isEditingMany() {
      return Array.isArray(this.entriesToEdit) && this.entriesToEdit.length > 1
    },

    isCreatingOrDeleting() {
      return ['create', 'delete'].indexOf(this.action) !== -1
    },
  },
  watch: {
    entry: {
      deep: true,
      handler() {},
    },
  },
  methods: {
    validate() {
      return this.$refs.refNetworkForm.validate()
    },
    reset() {
      return this.$refs.refNetworkForm.reset()
    },
    resetValidation() {
      return this.$refs.refNetworkForm.resetValidation()
    },
    closeNetworkForm() {
      if (!this.isCreatingOrDeleting) this.resetValidation()
      this.isModalVisibleNetwork = false
    },
    cancelForm() {
      this.entry = null
      this.closeNetworkForm()
    },
    errorForm(message) {
      const status = 'error'

      this.$store.commit('tools/snackbar', true, { root: true })
      this.$store.commit('tools/snack', { message, status }, { root: true })
    },

    pushNetwork() {
      pushNetwork(this.entry)
    },

    editNetworkList() {
      const action = 'edit'
      const scope = 'list'
      const entry = editNetworkList(this.networks)

      this.formDataForNetwork = { action, entry, scope }
      this.isModalVisibleNetwork = true
    },
    editNetwork(networkToEdit) {
      const action = 'edit'
      const scope = 'item'
      const entry = editNetwork(networkToEdit, this.networks)

      this.formDataForNetwork = { action, entry, scope }
      this.isModalVisibleNetwork = true
    },

    submitNetworkForm(successMessage) {
      const saveEdits = async () => {
        const { entry: entries } = this
        const networks = entries.reduce((entriesArray, entry, entryIndex) => {
          entriesArray.push({
            associationId: entry.associationId,
            index: entryIndex,
            subId: entry.subId,
          })

          return entriesArray
        }, [])
        const changes = { networks }
        const fnSuccess = () => {
          const message = successMessage
          const status = 'success'

          this.closeNetworkForm()
          this.$store.commit('tools/snackbar', true, { root: true })
          this.$store.commit('tools/snack', { message, status }, { root: true })
        }

        return this.$store.dispatch('auth/handleUpdateToUserSettings', { changes, fnSuccess }, { root: true })
      }

      return this.isCreatingOrDeleting || this.validate() ? saveEdits() : this.errorForm('Please fill required fields correctly.')
    },

    cancelDeleteNetwork() {
      this.denyDeleteNetwork = false
      this.promptDeleteNetwork = false
    },
    askDeleteNetwork(network) {
      this.deleteIndexNetwork = network.index
      this.deleteLabelNetwork = network.reportLabel
      this.promptDeleteNetwork = true
    },
    confirmDeleteNetwork(network, networks) {
      if (networks.length === 1) {
        this.denyDeleteNetwork = true
      } else {
        this.askDeleteNetwork(network)
      }
    },
    deleteNetwork() {
      const action = 'delete'
      const scope = 'item'
      const entry = deleteNetwork(this.deleteIndexNetwork, this.entry)

      this.formDataForNetwork = { action, entry, scope }
      this.submitNetworkForm('Deleted')
      this.promptDeleteNetwork = false
    },
    removeNetwork(index) {
      if (this.isEditingItem) {
        this.confirmDeleteNetwork(this.entry[index], this.entry)
      } else {
        this.entry.splice(index, 1)
      }
    },

    addFavoriteNetwork() {
      const action = 'create'
      const scope = 'item'
      const { currentNav } = this
      const { baseReportName, routeName } = currentNav
      const { associationId, reportPath, subId } = this.$route.query
      const networkToAdd = {
        associationId: associationId || null,
        index: this.networks.length,
        isEditing: true,
        reportPath: reportPath || null,
        baseReportName: baseReportName || null,
        routeName: routeName || null,
        subId: subId || null,
      }
      const entry = addNetwork(networkToAdd, this.networks)

      this.formDataForNetwork = { action, entry, scope }
      this.submitNetworkForm('Networked')
    },
    deleteFavoriteNetwork() {
      const { currentNav } = this
      const { baseReportName, routeName } = currentNav
      const { associationId, reportPath, subId } = this.$route.query
      const networkToRemove = this.networks.find((network) => network.routeName === routeName
        && network.baseReportName === baseReportName
        && network.reportPath === reportPath
        && network.associationId === associationId
        && network.subId === subId)

      if (networkToRemove) {
        const action = 'delete'
        const scope = 'item'
        const entry = editNetwork(networkToRemove, this.networks)

        this.formDataForNetwork = { action, entry, scope }
        this.confirmDeleteNetwork(networkToRemove, this.entry)
      } else {
        this.errorForm('Network not found.')
      }
    },
    toggleFavoriteNetwork() {
      if (this.isCurrentNetworkFavorited) {
        this.deleteFavoriteNetwork()
      } else {
        this.addFavoriteNetwork()
      }
    },
  },
}

export default NetworkMixin
